const state = {
    codeRecordList: [],
    backupServerList: [],
}
const mutations = {
    SET_CODERECORDLIST: (state, cover) => {
        state.codeRecordList = cover
    },
    SET_BACKUPSERVERLIST: (state, list) => {
        state.backupServerList = list
    },
}
export default {
    // 开启命名空间
    namespaced: true,
    mutations,
    state,
}